export const ConvertPackageDuration = (duration: string) => {
  const packageDurationMap = new Map([
    ["monthly", "Mensal"],
    ["quarterly", "Trimestral"],
    ["semi-annual", "Semi-anual"],
    ["annual", "Anual"],
  ]);

  return packageDurationMap.get(duration) || "";
};
